<template>
  <main class="pattern">

    <div class="container margin_60_40">

      <div class="invoice-content row px-5 pt-5">
        <div class="col-md-3 col-12">
          <h5 class="almost-gray mb-3">Thông tin khách hàng</h5>
          <p class="gray-ish"><b>Họ tên</b> : Nguyễn A</p>
          <p class="gray-ish"><b>Email</b> : Nguyễn A</p>
          <p class="gray-ish"><b>Số điện thoại</b> : 0999999</p>
          <p class="gray-ish"><b>Địa chỉ</b> : Client Adress spanning on two rows hopefully</p>
        </div>
        <div class="col-md-3 col-12">
          <h5 class="almost-gray">Mã đơn hàng</h5>
          <p class="gray-ish"># 123456789</p>

          <h5 class="almost-gray">Ngày nhận</h5>
          <p class="gray-ish">01 / 01 / 20 20 </p>

          <h5 class="almost-gray">Phương thức thanh toán</h5>
          <p class="gray-ish">Trả tiền mặt</p>

        </div>
        <div class="col-md-6 col-12 text-right total-field">
          <h4 class="almost-gray">Tổng thanh toán</h4>
          <h1 class="gray-ish">100.000 VNĐ</h1>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-10 offset-1 invoice-table pt-1">
          <table class="table table-hover">
            <thead class="thead splitForPrint">
            <tr>
              <th scope="col gray-ish">NO.</th>
              <th scope="col gray-ish">Item</th>
              <th scope="col gray-ish">Qty.</th>
              <th scope="col gray-ish">U. Price</th>
              <th scope="col gray-ish">VAT %</th>
              <th scope="col gray-ish">Discount</th>
              <th class="text-right" scope="col gray-ish">Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row">1</th>
              <td class="item">Item 1</td>
              <td>1</td>
              <td>25 <span class="currency">&euro;</span></td>
              <td>5 %</td>
              <td>5 %</td>
              <td class="text-right">28,75 <span class="currency">&euro;</span></td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td class="item">Item 2</td>
              <td>1</td>
              <td>25 <span class="currency">&euro;</span></td>
              <td></td>
              <td>5 %</td>
              <td class="text-right">28,75 <span class="currency">&euro;</span></td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td class="item">Item 3</td>
              <td>1</td>
              <td>25 <span class="currency">&euro;</span></td>
              <td>13 %</td>
              <td>5 %</td>
              <td class="text-right">28,75 <span class="currency">&euro;</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row invoice_details">
        <!-- invoiced to details -->
        <div class="col-md-4 col-12 offset-1 pt-3">
          <h4 class="gray-ish">Ghi chú đơn hàng</h4>
          <p class="pt-3 almost-gray">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas tincidunt
            condimentum quam, ut porttitor dui ultricies nec.</p>
        </div>
        <!-- Invoice assets and total -->
        <div class="offset-1 col-md-5 col-12 mb-3 pr-4 sub-table">
          <table class="table table-borderless">
            <tbody>
            <tr>
              <th scope="row gray-ish">Giá sản phẩm</th>
              <td class="text-right">75.000 VNĐ</td>
            </tr>
            <tr>
              <th scope="row gray-ish">Giảm Giá</th>
              <td class="text-right">0 VNĐ</td>
            </tr>

            <tr>
              <th scope="row gray-ish">Vận chuyển</th>
              <td class="text-right">30.000 VNĐ</td>
            </tr>
            <tr class="last-row" style="color: white !important;">
              <th scope="row"><h4>Tổng</h4></th>
              <td class="text-right text-white"><h4>100.000 VNĐ</h4></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-4 justify-content-center" style="margin-top: 50px">
        <div class="col-md-6 col-12 text-center">
          <a href="https://merchant.monmi.vn" class="btn_1 w-100" style="width: 50%;">Theo dõi đơn hàng</a>
        </div>
      </div>
      <!-- /col -->
    </div>
    <!-- /container -->

  </main>
</template>

<script>
export default {
  name: "OrderSuccess"
}
</script>

<style scoped>
@page {
  bleed: 1cm;
  size: A4 portrait;
  size: auto;   /* auto is the initial value */
  margin-bottom: 50pt;
  margin-top: 0cm;
  font-size: 12pt;

#content, #page {
  width: 100%;
  margin: 0;
  float: none;
}

}


@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  table {
    page-break-inside: auto;
  }

  tr.last-row > th, tr.last-row > td {

  }

  div.page-break {
    page-break-before: auto;
  }
}

.gray {
  color: #333;
}

.gray-ish {
  color: #666;
}

.almost-gray {
  color: #999;
}

body {
  background-color: #eee;
  padding-top: 25px;
  -webkit-print-color-adjust: exact !important;
  height: 100%;
  margin-top: 40px;
}

/*div.container {*/
/*  background-color: white;*/
/*  border-radius: 10px;*/
/*  height: 100%;*/
/*  position: relative;*/
/*  margin-top: 50px;*/
/*}*/

div.invoice-header {
  background-color: #444;
  color: white;
  border-bottom: 3px solid rgb(255, 77, 77);
}

div.invoice-header > div > p {
  font-size: 1.2rem;
  font-weight: 350;
}

div.invoice-header > div > h1 {
  font-size: 4rem;
}

div.invoice-table {
  border-top: 3px solid rgb(255, 77, 77);
}

div.invoice-table > table.table > thead, div.invoice-table > table.table > thead.thead > tr, div.invoice-table > table.table > thead.thead > tr > th {
  border-top: none;
}

div.total-field {
  position: relative;
}

h5.due-date {
  position: absolute;
  bottom: 10px;
  right: 15px;
}

div.sub-table {
  border-left: 3px solid rgb(255, 77, 77);
  padding-left: 0;
}

div.sub-table > table {
  padding-bottom: 0;
  margin-bottom: 0;
}

tr.last-row {
  margin-top: 25px;
  color: white;
  border-top: 3px solid rgb(255, 77, 77);
}

p.footer {
  bottom: 0;
  width: 100%;
  background-color: #333;
  color: white;
  padding-top: 15px;
  border-top: 3px solid red;
}
@media (max-width: 600px) {
  .almost-gray{
    font-size: 18px;
  }
  .gray-ish{
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderSuccess.vue